import { login, smsLogin, getInfo, bindWeChat, bindQQ } from '@/api/user'
import { getToken, setToken, removeToken, setUserInfo, removeUserInfo } from '@/libs/cookie-storage'

const user = {
  state: {
    token: getToken(),
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const userName = userInfo.userName.trim()
      return new Promise((resolve, reject) => {
        login(userName, userInfo.password).then(response => {
          const data = response.data
          if (data.session && data.session.id) {
            setToken(data.session.id)
            setUserInfo(data.user)
            commit('SET_TOKEN', data.session.id)
            commit('SET_INFO', data.user)
            bindWeChat()
            bindQQ()
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登录
    SmsLogin({ commit }, userInfo) {
      const userName = userInfo.userName.trim()
      return new Promise((resolve, reject) => {
        smsLogin(userName, userInfo.smsCode, userInfo).then(response => {
          const data = response.data
          if (data.session && data.session.id) {
            setToken(data.session.id)
            setUserInfo(data.user)
            commit('SET_TOKEN', data.session.id)
            commit('SET_INFO', data.user)
            bindWeChat() // TODO 如果绑定过可以不再尝试绑定
            bindQQ()
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token).then(response => {
          const user = response.data.users
          resolve(user)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        removeUserInfo()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js